export const DOCS_NAV = [
    {
        title: 'Docs.privacyPolicy',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/privacy-policy',
    },
    {
        title: 'Docs.loyaltyProgram&WithdrawalLimits',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/loyalty-program-withdrawal-limits',
    },
    {
        title: 'Docs.amlPolicyAntiMoneyLaundering',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/aml-policy',
    },
    {
        title: 'Docs.licensePage',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/license',
    },
    {
        title: 'Docs.refund&CancellationPolicy',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/refund-cancellation-policy',
    },
    {
        title: 'Docs.antiFraudPolicy',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/anti-fraud-policy',
    },
    {
        title: 'Docs.disputeResolution',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/dispute-resolution',
    },
    {
        title: 'Docs.cookiesPolicy',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/cookies-policy',
    },
    {
        title: 'Docs.airdrop&PromotionTerms',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/airdrop-promotions-terms',
    },
    {
        title: 'Docs.selfExclusion',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/self-exclusion',
    },
    {
        title: 'Docs.lottery&RngGames',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/lottery-rng-games',
    },
    {
        title: 'Docs.convert&CurrencyEchange',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/convert-currency-exchange',
    },
    {
        title: 'Docs.payoutAudits',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/payout-audits',
    },
    {
        title: 'Docs.currencyConversion',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/currency-conversion',
    },
    {
        title: 'Docs.bigWin',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/big-win',
    },
    {
        title: 'Docs.playerCodeOfConduct',
        lastUpdated: 'Docs.lastUpdated',
        href: '/docs/player-code-of-conduct',
    }
]
